/**
 * 获取粤康码信息
 * @param {*} custCertNo 身份证号
 * @param {*} custName 姓名
 * @returns 
 */
let getHealthInfoByIdCard = (custCertNo, custName) => {
   return new Promise((resolve, reject) => {
      if (window.framework) {
         try {
            // 获取粤康码信息回调
            var healthInfofun = function (obj) {
               var healthInfo = JSON.parse(obj)
               if (healthInfo.success == true) {
                  resolve(healthInfo)
               } else {
                  reject(healthInfo.msg)
               }
            }
            window.callHealthInfoByIdCard = healthInfofun.bind(this);
            // 调用获取粤康码信息
            window.framework.jsGetHealthInfoByIdCard(custCertNo, custName);
         } catch (error) {
            reject(error)
         }
      }
   })
}

/**
 * 设置微信配置
 */
const setWXConfig = () => {
   return new Promise((resolve, reject) => {
      http
         .post(
            "https://wx.open.class.busboss.cn/Weixin/JSAPI",
            qs.stringify({
               url: encodeURIComponent(window.location.href.split("#")[0]),
               AppID: "wx5e2cde762ffa2228",
            })
         )
         .then(function (t) {
            if (t) {
               // eslint-disable-next-line no-undef
               wx.config({
                  debug: !1,
                  // debug: 1,
                  appId: t.appId,
                  timestamp: parseInt(t.timestamp),
                  nonceStr: t.noncestr,
                  signature: t.signature,
                  jsApiList: ["scanQRCode"],
               });
            }
            console.log('setWXConfig:success', t)
            resolve(t)
         }).catch(err => {
            console.log('setWXConfig:err', err)
            reject(err)
         });
   })
}

const getIsWxClient = () => {
   var ua = navigator.userAgent.toLowerCase()
   if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
   }
   return false
}

/**
 * 调起摄像头扫码
 * @param {*} func app环境下的回调函数
 * @returns 
 */
const scanQRCode = (func) => {
   return new Promise((resolve, reject) => {
      //调起摄像头扫码
      if (window.framework && window.framework.jsCameraScan) {
         // 摄像头扫码回调
         var callCameraScanfun = function (code) {
            resolve(code);
         }
         window.callCameraScan = callCameraScanfun.bind(this);
         window.framework.jsCameraScan();
      }
      // 判断微信内置浏览器
      else if (getIsWxClient()) {
         wx.ready(() => {
            wx.scanQRCode({
               needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
               scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
               success: function (codeRes) {
                  var qrCode = codeRes.resultStr; // 当needResult 为 1 时，扫码返回的结果
                  console.log('scanQRCode:success', codeRes, qrCode)
                  resolve(codeRes);
               },
               fail: (err) => {
                  console.log('scanQRCode:err', err);
                  reject(err);
               },
            });
         });
      } else {
         reject("调起扫码失败，请检查设备！");
      }
   })
}

export {
   getHealthInfoByIdCard,
   setWXConfig,
   scanQRCode
}